/* eslint-disable */
<template>
<vue-hcaptcha 
      :sitekey="hcaptchaSitekey"
      >
</vue-hcaptcha>
</template>

<script>
//vCaptcha
  import VueHcaptcha from '@hcaptcha/vue-hcaptcha'
  import Common from '@/scripts/Common.js'
  import { abstractField } from "vue-form-generator";

  export default {
      mixins: [ abstractField ],
      name: 'fieldRecaptcha',
      data() {
          return {
              hcaptchaSitekey: this.gethCaptchaSitekey()
          }
      },
      components: {
          VueHcaptcha
      },
      methods: {
          gethCaptchaSitekey(){
            if(Common.getAMBIENTE()=='SVI'){
                return '3cd0ca00-02e6-471c-832c-0912485864a0';
            }
            if(Common.getAMBIENTE()=='PRE'){
                return '3cd0ca00-02e6-471c-832c-0912485864a0';
            }
            else{
                return 'a1d04264-cbbc-4a7c-9f78-9eb6f5e23f48';
            }
          },

      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only-->
<style scoped>

</style>
